function EventName({name}){
  return(
    <div className="details-event-name">
      {name}
    </div>
  );
}

export default EventName;
